// Session 127 — "How we met" date helpers. The backend stores met-dates
// as ISO YYYY-MM-DD; older records may carry free-form strings like
// "Jun 28, 2026". Coerce to ISO where possible so the date picker in
// the edit form can always render the value.
export function toIsoDate(value) {
  if (!value) return '';
  const v = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(v)) return v.slice(0, 10);
  const t = Date.parse(v);
  if (!Number.isNaN(t)) {
    const d = new Date(t);
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }
  return v; // unparseable free-form — keep as typed
}

/** Today, in the same short form the scan page stores in When. */
export function todayMetLabel(date = new Date()) {
  return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

// Display an ISO met-date as "Jun 28, 2026"; free-form values pass through.
export function formatMetDate(value) {
  if (!value) return '';
  const v = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
    const [y, m, d] = v.split('-').map(Number);
    return new Date(y, m - 1, d).toLocaleDateString(undefined, {
      year: 'numeric', month: 'short', day: 'numeric',
    });
  }
  return v;
}
